import React from "react";
import {
  Box,
  Button,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  defaultObstacleIllustrations,
  resolveObstacleIllustrations,
} from "../../../../frontend/src/utils/mineCartPlacement";
import { imageUrl } from "../../utils/scenarioVariants";
export default function MineCartObstaclesEditor({
  base,
  config,
  value,
  disabled,
  onChange,
  onUpload,
}) {
  const rows = value || defaultObstacleIllustrations(base);
  const resolved = resolveObstacleIllustrations(config, rows, (image) => image);
  const edit = (id, patch) =>
    onChange(rows.map((row) => (row.id === id ? { ...row, ...patch } : row)));
  const fileInput = (callback) => (
    <input
      hidden
      type="file"
      accept="image/png,image/jpeg,image/webp"
      onChange={(e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (file) onUpload(file, callback);
      }}
    />
  );
  return (
    <Stack spacing={2}>
      <Typography variant="body2">
        La hauteur est celle de l’image, en % de la zone de scène. Sans réglage,
        le placement hérité est conservé. Chaque illustration du banc sera
        utilisée avant de recommencer.
      </Typography>
      {rows.map((row, i) => (
        <Stack
          key={row.id}
          spacing={1}
          sx={{ border: "1px solid", borderColor: "divider", p: 1 }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            {resolved[i].image?.source && (
              <Box
                component="img"
                alt={row.label}
                src={imageUrl(resolved[i].image.source)}
                sx={{ width: 64, height: 64, objectFit: "contain" }}
              />
            )}
            <TextField
              label="Nom de l’obstacle"
              value={row.label}
              disabled={disabled}
              inputProps={{ maxLength: 80 }}
              fullWidth
              size="small"
              onChange={(e) => edit(row.id, { label: e.target.value })}
            />
          </Stack>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
            <TextField
              label="Type visuel"
              select
              value={row.kind}
              size="small"
              fullWidth
              disabled={disabled || !!row.reference}
              onChange={(e) => edit(row.id, { kind: e.target.value })}
            >
              {(base.obstacles || base.projectiles).map((kind) => (
                <MenuItem key={kind} value={kind}>
                  {kind}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label="Hauteur (% de la scène)"
              type="number"
              size="small"
              fullWidth
              value={row.heightPct ?? ""}
              placeholder="Héritée"
              disabled={disabled}
              inputProps={{ min: 1, max: 80, step: 0.5 }}
              onChange={(e) => {
                const next = { ...row };
                if (e.target.value === "") delete next.heightPct;
                else next.heightPct = Number(e.target.value);
                onChange(rows.map((r) => (r.id === row.id ? next : r)));
              }}
            />
          </Stack>
          <Stack direction="row" flexWrap="wrap">
            <Button component="label" disabled={disabled}>
              Remplacer l’image
              {fileInput((image) => {
                const next = { ...row, image };
                delete next.reference;
                onChange(rows.map((r) => (r.id === row.id ? next : r)));
              })}
            </Button>
            <Button
              disabled={disabled || rows.length >= 32}
              onClick={() =>
                onChange([
                  ...rows,
                  {
                    ...row,
                    id: crypto.randomUUID(),
                    label: `${row.label} copie`.slice(0, 80),
                  },
                ])
              }
            >
              Dupliquer l’obstacle
            </Button>
            <Button
              disabled={disabled || rows.length <= 1}
              onClick={() => onChange(rows.filter((r) => r.id !== row.id))}
            >
              Retirer
            </Button>
          </Stack>
        </Stack>
      ))}
      <Stack direction="row" flexWrap="wrap">
        <Button component="label" disabled={disabled || rows.length >= 32}>
          Ajouter un obstacle
          {fileInput((image) =>
            onChange([
              ...rows,
              {
                id: crypto.randomUUID(),
                label: "Nouvel obstacle",
                kind: (base.obstacles || base.projectiles)[0],
                image,
                heightPct: 20,
              },
            ]),
          )}
        </Button>
        <Button
          disabled={disabled || !value}
          onClick={() => onChange(undefined)}
        >
          Revenir au banc du modèle
        </Button>
      </Stack>
    </Stack>
  );
}
